import MainLayout from "../mainlayout/MainLayout";
import { useState, useEffect } from "react";
import DisplayPlan from "../modal/DisplayPlan";
import style from "../planmaker/Plan.css";

const Plan = () => {
  const [startdate, setStartDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [enddate, setEndDate] = useState("");
  const [timeslot, setTimeSlot] = useState("");
  const [goal, setGoal] = useState("");
  const [tasks, setTasks] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const savePlan = async () => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_NODEURL}/getTask`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        start: new Date(startdate),
        end: new Date(enddate),
      }),
    });
    let ans = await response.json();
    let plan = "";
    if ((ans.msg = "SUCCESS")) {
      plan = JSON.stringify(ans.res);
    }

    let prompt = `You are an AI assistant that creates highly detailed daily task plans in JSON format for goal tracking apps.

Goal: ${goal}
Start Date: ${startdate}
End Date: ${enddate}
Preferred Timeslots: ${timeslot}
Existing Plan: ${plan}

Instructions:
1. Break the goal into small, **specific, detailed tasks** for each day. Avoid vague terms like "prepare" or "study".
   - Examples of good tasks: 
     - “Solve 2 Leetcode problems on recursion”
     - “Update resume: projects section”
     - “Write 1-page cover letter draft for frontend role”
2. Respect the preferred timeslots and avoid conflicting with the existing plan.
3. For each task, provide:
   - "tasks": a detailed task description
   - "status": always "Pending"
   - "date": in the format "YYYY-MM-DDT00:00:00.000Z"
   - "startTime" and "endTime": in format "YYYY-MM-DDTHH:mm"

4. Tasks must match your preferred time durations and spacing — split long sessions if needed.
5. Return only valid JSON array. Do not include explanations or markdown.
6. Give me two best resources for each task either blog or video (LINK SHOULD WORK CORRECTLY mainly youtube link should be WORKABLE and avoid subscribed blogs and links should have relevant content)
7. Return only  **VALID RAW JSON ARRAY**, without markdown formatting, headers, explanations, or code blocks, WITHOUT MARKDOWN FORMATTING !!!!!!!!!!!! important !!!!!!!important

Example format:
[
  {
    "tasks": "Solve 2 Leetcode problems on sliding window",
    "status": "Pending",
    "date": "2025-04-09T00:00:00.000Z",
    "startTime": "2025-04-09T07:00:00",
    "endTime": "2025-04-09T08:30",
    "resources":[{name:"",link:""}]
  }
]   `;
    // https://aiplanner-civ5.onrender.com
    let res = await fetch("https://aiplanner-kp43.onrender.com/ask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        prompt: prompt,
      }),
    });
    let result = await res.json();
    console.log(result);
    if (result && result.response) {
      setLoading(false);
      let content = JSON.parse(result.response).choices[0].message.content;
      if (content.startsWith("```")) {
        content = content.replace(/```(?:json)?/i, "").trim();
        content = content.replace(/```$/, "").trim();
      }
      setTasks(JSON.parse(content));
      setIsModalOpen(true);
    } else {
      console.error("Invalid response from API: ", result);
    }
  };

  return (
    <>
      <MainLayout>
        <DisplayPlan
          isOpen={isModalOpen}
          tasks={tasks}
          goal={goal}
          startdate={startdate}
          enddate={enddate}
        />

        {loading && (
          <div className="loader-overlay">
            <div className="loader">
              <div className="loaderBar"></div>
              <div className="loaderBar"></div>
              <div className="loaderBar"></div>
              <div className="loaderBar"></div>
              <div className="loaderBar"></div>
            </div>
            <p className="loading-text">
              Your Plan is getting ready. Please wait...
            </p>
          </div>
        )}

        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="w-full max-w-xl bg-black rounded-2xl shadow-2xl p-6 space-y-6 border border-purple-900/50">
            <h2 className="text-2xl font-semibold text-purple-300/90 tracking-wide text-left">
              Plan Your Goal
            </h2>

            {/* Date Range */}
            <div className="text-left">
              <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
                Date Range
              </label>
              <div className="flex gap-4">
                <input
                  type="date"
                  name="start_date"
                  onChange={(e) => setStartDate(e.target.value)}
                  className="flex-1 p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                />
                <input
                  type="date"
                  name="end_date"
                  onChange={(e) => setEndDate(e.target.value)}
                  className="flex-1 p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50"
                />
              </div>
            </div>

            {/* Goal / Topic */}
            <div className="text-left">
              <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
                Goal / Topic
              </label>
              <textarea
                name="goal"
                placeholder="e.g. Learn MySQL"
                onChange={(e) => setGoal(e.target.value)}
                className="w-full p-3 text-sm rounded-lg bg-[#161622] text-purple-100 border border-purple-900/50 focus:outline-none focus:ring-1 focus:ring-purple-500/50 focus:border-purple-500/50 placeholder-purple-100/70 resize-none"
                rows="4"
              ></textarea>
            </div>

            {/* Time Slots */}
            <div className="text-left">
              <label className="block text-xs font-medium text-purple-300/80 mb-2 tracking-wider uppercase">
                Preferred Time Slot
              </label>
              <div className="flex gap-6">
                {["morning", "evening", "night"].map((slot) => (
                  <label
                    key={slot}
                    className="inline-flex items-center gap-2 text-purple-100/90"
                  >
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        name="timing"
                        value={slot}
                        onChange={(e) => setTimeSlot(e.target.value)}
                        className="opacity-0 absolute h-5 w-5"
                      />
                      <div
                        className={`w-5 h-5 rounded-md border ${
                          timeslot === slot
                            ? "border-purple-500 bg-purple-500/20"
                            : "border-purple-700"
                        } flex items-center justify-center`}
                      >
                        {timeslot === slot && (
                          <svg
                            className="w-3 h-3 text-purple-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                    <span>{slot.charAt(0).toUpperCase() + slot.slice(1)}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-right">
              <button
                type="button"
                onClick={savePlan}
                className="px-6 py-2 text-sm rounded-md bg-purple-900/60 text-purple-100 hover:bg-purple-800/60 transition-colors border border-purple-800/50 shadow-[0_1px_1px_0px_rgba(139,92,246,0.2)]"
              >
                Submit Plan
              </button>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default Plan;
